import script from "./EventoEditorView.vue?vue&type=script&setup=true&lang=js"
export * from "./EventoEditorView.vue?vue&type=script&setup=true&lang=js"

import "./EventoEditorView.vue?vue&type=style&index=0&id=29c3bbf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29c3bbf8"]])

export default __exports__